import { ChevronLeft, ChevronRight } from 'lucide-react';

type Props = {
  currentPage: number;
  totalPages: number;
  onPageChange: (page: number) => void;
  prevLabel?: string;
  nextLabel?: string;
};

export const Pagination = ({
  currentPage,
  totalPages,
  onPageChange,
  prevLabel = 'Previous',
  nextLabel = 'Next'
}: Props) => {
  const count = Math.max(1, totalPages);
  const pages = Array.from({ length: count }, (_, i) => i + 1);

  return (
    <nav className="pagination-bar" aria-label="Pagination">
      <button
        type="button"
        className="pagination-btn pagination-prev"
        disabled={currentPage <= 1 || totalPages <= 1}
        onClick={() => onPageChange(currentPage - 1)}
        aria-label="Previous page"
      >
        <ChevronLeft size={16} aria-hidden="true" />
        <span>{prevLabel}</span>
      </button>

      <div className="pagination-dots" role="tablist" aria-label="Page selection">
        {pages.map((page) => {
          const isActive = page === currentPage;
          return (
            <button
              key={page}
              type="button"
              className={`pagination-dot ${isActive ? 'pagination-dot-active' : ''}`}
              aria-current={isActive ? 'page' : undefined}
              aria-label={`Page ${page}`}
              disabled={totalPages <= 1}
              onClick={() => onPageChange(page)}
            />
          );
        })}
      </div>

      <button
        type="button"
        className="pagination-btn pagination-next"
        disabled={currentPage >= totalPages || totalPages <= 1}
        onClick={() => onPageChange(currentPage + 1)}
        aria-label="Next page"
      >
        <span>{nextLabel}</span>
        <ChevronRight size={16} aria-hidden="true" />
      </button>
    </nav>
  );
};
